<template>
  <div>
    <VMessage
      type="warning"
      :fullwidth="true"
      v-if="permissionCompany !== true"
    >
      <template v-slot:icon>
        <ExclamationTriangleIcon />
      </template>
      <template v-slot:text>
        {{ $t("companySettings.company.permissionWarning") }}
      </template>
    </VMessage>
    <div ref="container" v-if="permissionCompany === true">
      <CompanySharing class="lg:w-2/3 xl:w-1/2" />
    </div>
  </div>
</template>
<script>
import VMessage from '@/components/deprecated/atoms/Message.vue';
import CompanySharing from '@/components/CompanySharing.vue';
import { mapGetters } from 'vuex';
import { ExclamationTriangleIcon } from '@/components/icons/fontIcons';

export default {
  name: 'DeveloperDefaultSharingPermissions',
  components: {
    VMessage,
    CompanySharing,
    ExclamationTriangleIcon,
  },
  computed: {
    ...mapGetters({
      userHasRole: 'roles/userHasRole',
    }),
    permissionCompany() {
      return this.userHasRole('super-admin');
    },
  },
};
</script>
